import dayjs from 'dayjs';

import { useSuspenseQuery } from '@tanstack/react-query';
import { TypeGetRecruitNoticesWorkDatesResponse } from '~/api/recruitNotices';
import { registerMockAPI } from '~/mocks/mockApis';

import { axiosInstance } from '~/services/fetchServiceV2';
import { formatDate } from '~/utils';

export const WORK_DATES_QUERY_KEY = 'work-dates';

/** @description 근무지별 모집중인 근무일자 목록 조회 */
export const useGetWorkDates = (workLocationId: string) => {
  const { data } = useSuspenseQuery({
    queryKey: [WORK_DATES_QUERY_KEY, workLocationId],
    queryFn: async () => {
      const endpoint = '/recruit-notices/work-dates';
      return await axiosInstance.get<TypeGetRecruitNoticesWorkDatesResponse>(endpoint, {
        params: { workLocationId },
      });
    },
    gcTime: 0,
    retry: 1,
    select: (response) => response.data.data ?? [],
  });

  return { data };
};

const MOCK_BASE_DATE = dayjs('2026-01-19');

registerMockAPI<TypeGetRecruitNoticesWorkDatesResponse>({
  method: 'get',
  endpoint: '/recruit-notices/work-dates',
  label: '근무 희망 날짜 선택/근무일자 목록 조회',
  scenarios: [
    {
      name: '모두 지원 가능 (4개)',
      response: {
        code: '200',
        message: 'OK',
        data: [
          { workDate: formatDate({ value: MOCK_BASE_DATE }), hasApplication: false },
          { workDate: formatDate({ value: MOCK_BASE_DATE.add(1, 'day') }), hasApplication: false },
          { workDate: formatDate({ value: MOCK_BASE_DATE.add(2, 'day') }), hasApplication: false },
          { workDate: formatDate({ value: MOCK_BASE_DATE.add(3, 'day') }), hasApplication: false },
        ],
      },
    },
    {
      name: '지원 이력 존재 (2개)',
      response: {
        code: '200',
        message: 'OK',
        data: [
          { workDate: formatDate({ value: MOCK_BASE_DATE }), hasApplication: true },
          { workDate: formatDate({ value: MOCK_BASE_DATE.add(1, 'day') }), hasApplication: false },
          { workDate: formatDate({ value: MOCK_BASE_DATE.add(2, 'day') }), hasApplication: false },
          { workDate: formatDate({ value: MOCK_BASE_DATE.add(3, 'day') }), hasApplication: true },
        ],
      },
    },
    {
      name: '모두 지원 이력 존재',
      response: {
        code: '200',
        message: 'OK',
        data: [
          { workDate: formatDate({ value: MOCK_BASE_DATE }), hasApplication: true },
          { workDate: formatDate({ value: MOCK_BASE_DATE.add(1, 'day') }), hasApplication: true },
          { workDate: formatDate({ value: MOCK_BASE_DATE.add(2, 'day') }), hasApplication: true },
          { workDate: formatDate({ value: MOCK_BASE_DATE.add(3, 'day') }), hasApplication: true },
        ],
      },
    },
    {
      name: '지원 불가',
      response: {
        code: '200',
        message: 'OK',
        data: [],
      },
    },
  ],
});
